var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.4 35.5H55.1c-.1 0-.2 0-.3-.2-1.6-2.5-4.3-4.2-7.5-4.2s-5.9 1.7-7.5 4.2c0 0-.2.2-.3.2H21.1c-.2 0-.4.1-.4.4v8.2c0 .2.1.4.4.4h18.3c.1 0 .2 0 .3.2 1.6 2.5 4.3 4.3 7.5 4.3s6-1.7 7.5-4.3c0-.1.2-.2.3-.2h18.2c.2 0 .4-.1.4-.4v-8.2c0-.2-.2-.4-.4-.4h.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M47.4 49.8c-3.3 0-6.4-1.6-8.2-4.4H21.3c-.7 0-1.4-.6-1.4-1.4v-8.2c0-.7.6-1.4 1.4-1.4h18c1.8-2.7 4.8-4.3 8.1-4.3s6.3 1.6 8.1 4.3h17.9c.7 0 1.3.6 1.4 1.3V44c0 .7-.6 1.4-1.4 1.4H55.5c-1.8 2.7-4.9 4.4-8.2 4.4h.1Zm-25.5-6.4h17.7c.4 0 .9.2 1.1.6 1.5 2.4 4 3.8 6.7 3.8s5.3-1.4 6.7-3.8c.3-.4.7-.6 1.2-.6h17.6v-6.9H55.3c-.4 0-.9-.2-1.1-.6-1.5-2.4-3.9-3.7-6.7-3.7s-5.2 1.4-6.6 3.7c-.3.4-.7.6-1.1.6H22.1v6.9h-.2Z"
  })));
};
export default SvgBand;